import { useMemo } from "react";

function normalizeCardId(routeCardId) {
  if (!routeCardId) {
    return null;
  }

  return routeCardId.split("-")[1] ?? routeCardId;
}

export function useBoardCardNavigation({ cards = [], routeCardId, enabled }) {
  return useMemo(() => {
    if (!enabled) {
      return {
        activeCardId: null,
        cardsOnBoard: [],
      };
    }

    const activeCardId = normalizeCardId(routeCardId);

    if (!activeCardId) {
      return {
        activeCardId: null,
        cardsOnBoard: [],
      };
    }

    const currentCard = cards.find(
      (item) => String(item?.card?.card_id) === String(activeCardId)
    );
    const workflowStepId = currentCard?.card?.workflow_step_id;

    if (!workflowStepId) {
      return {
        activeCardId,
        cardsOnBoard: [],
      };
    }

    const cardsOnBoard = cards
      .filter((item) => item?.card?.workflow_step_id === workflowStepId)
      .sort((cardA, cardB) => {
        const sequenceA = cardA?.card?.card_sequence ?? 0;
        const sequenceB = cardB?.card?.card_sequence ?? 0;

        return sequenceA - sequenceB;
      });

    return {
      activeCardId,
      cardsOnBoard,
    };
  }, [cards, enabled, routeCardId]);
}
